import React from "react";
import { useField, useFormikContext } from "formik";
import { DatePicker } from "@mui/x-date-pickers";

export const DatePickerField = ({ ...props }: any) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field] = useField(props);
  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        //setFieldTouched(field.name);
        setFieldValue(field.name, val, true);
      }}
    />
  );
};
